export const playAnimation = (elementId, SVGId) => {
    let svgObject = document.getElementById(elementId).contentDocument;
    let svgContent = svgObject.getElementById(SVGId);
    svgContent.dispatchEvent(new Event("click"));
};